import { IntermediaryUsersListModule, PageHeader, buttonVariants } from '@korint/folio';
import { PlusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

export function IntermediaryUsersList() {
  return (
    <div>
      <PageHeader
        title="Utilisateurs"
        right={
          <Link to="/intermediary-user-form" className={buttonVariants({ size: 'sm' })}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Inviter un utilisateur
          </Link>
        }
      />
      <IntermediaryUsersListModule />
    </div>
  );
}
